import React from "react";

const Paragraph = ({ children, className = "" }) => {
  return (
    <p className={`text-base text-black  text-justify font-medium ${className}`}>
      {children}
    </p>
  );
};

export default Paragraph;
